import moment from 'moment'

// convert 1 to 1st, 2 to 2nd, etc.
export const getOrdinalNumber = (number?: number) => {
  if (!number) {
    return
  }

  return moment().dayOfYear(number).format('DDDo')
}
